import dLogoUrl from '@/assets/Logo/do-compact-black.svg'
import { APP_SHORT_NAME } from '@/helpers/constants'
import { useDesignMode } from '@/features/designMode/designModeStore'
import { useSecondaryNavStore } from '@/store/secondaryNavStore'
import WorkspaceTiles from './WorkspaceTiles.jsx'
import styles from './PrimaryLeftNavigation.module.scss'

export default function PrimaryLeftNavigation() {
  const designMode = useDesignMode()
  const collapsed = useSecondaryNavStore((state) => state.collapsed)
  if (designMode) return null
  return (
    <nav
      className={`${styles.rail}${collapsed ? ` ${styles.railCollapsed}` : ''}`}
      aria-label="Primary navigation"
      aria-hidden={collapsed}
    >
      <div className={styles.brand}>
        <img className={styles.logo} src={dLogoUrl} alt={APP_SHORT_NAME} draggable={false} />
      </div>
      <WorkspaceTiles />
    </nav>
  )
}
